import {Text, TextProps} from 'platform/foundation';

import {MouseEventHandler, ReactElement, ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

import {Placement} from '../../../types/Placement';
import {Button, ButtonProps} from '../../Button/Button';
import {DropdownSizeType} from './DropdownSizeType';
import {DropdownVariantType} from './DropdownVariantType';

export type DropdownProps = {
  dropdownControl?: ReactElement<ButtonProps, typeof Button> | ReactElement<TextProps, typeof Text>;
  children: ReactNode;
  placement?: Placement;
  isOpen?: boolean;
  hasSearch?: boolean;
  onOpen?(): void;
  onClose?(): void;
  isHeightLimited?: boolean;
  defaultIsOpen?: boolean;
  closeOnSelect?: boolean;
  closeOnBlur?: boolean;
  isLazy?: boolean;
  onButtonClick?: MouseEventHandler<HTMLButtonElement>;
  strategy?: 'fixed' | 'absolute';
  isMatchingReferenceWidth?: boolean;
  boundary?: 'clippingParents' | 'scrollParent' | HTMLElement;
  variant?: DropdownVariantType;
  lazyBehavior?: 'unmount' | 'keepMounted';
  size?: DropdownSizeType;
  isDisabled?: boolean;
  isFocusManagementDisabled?: boolean;
  isKeyboardNavigationDisabled?: boolean;
} & TestIdProps;
